<script setup lang="ts">
import { computed } from 'vue';
import { formatCurrency } from '@peanuds/shared';

const { row } = defineProps<{ row: { balance?: number; currency?: string } }>();

const formatted = computed(() =>
  formatCurrency(row.balance ?? 0, row.currency as 'EUR' | 'USD' | 'GBP'),
);
</script>

<template>
  <span class="cell-balance">{{ formatted }}</span>
</template>
